import { cloneDeep, clone } from 'lodash'
import create, { SetState, StateCreator, StoreApi } from 'zustand'

type Params = {
    page: number,
    limit: number,
    sortBy?: string,
    sortType?: 'ASC' | 'DESC'
}

type Filter = {
    columnName: string,
    searchText: string
}

export interface LabsStore {
    data : any,
    noData: boolean,
    setnoData: (noData: boolean) => void,
    setdata : (x:any) => void
    count: number,
    setcount: (count: number) => void,
    dataCardId?: number,
    setdataCardId: (x: number) => void,
    fetchRedValues: boolean,
    setfetchRedValues: (fetchRedValues: boolean) => void,
    params: Params,
    setPage: (page: Params['page']) => void,
    setLimit: (limit: Params['limit']) => void,
    setSorting: (sortBy: Params['sortBy'], sortType: Params['sortType']) => void,
    setParams: (params: Params) => void
    resetParams: () => void
    filters: Filter[],
    setFilter: (columnName: Filter['columnName'], FilterText: Filter['searchText']) => void
    clearFilter: (columnName: Filter['columnName']) => void
    resetFilter: () => void
    resetAll: () => void
    clearStore: () => void,
    patientId?: number,
    setPatientId: (x: number) => void,
}
let initialInput : any[]
// const initialInput: any[] = new Array(13).fill(null).map(
//     (v, i) => {
//         const inRange = i%3 === 0 ? 'Y' : (
//             i%3 ===1 ? 'N' : 'NA'
//         )
//         return {
//             lab_date: `2023-01-${i+1}`,
//             lab_description: `desc_${i}`,
//             lab_value: 108 + i,
//             lab_units: 'mg/dL',
//             lab_range: "80-120",
//             in_range: inRange
//         }
//     }
// )

const applySearchFilter = (filterso: LabsStore['filters'] , columnName: Filter['columnName'], searchText?: Filter['searchText']) => {
    const filter = {
        columnName,
        searchText: searchText || ''
    }

    let filters = cloneDeep(filterso)
    
    const alreadyExists = filters.findIndex(
        f => (f.columnName === columnName)
    )

    if (searchText) {
        if (alreadyExists >=0) {
            filters[alreadyExists] = filter
        } else {
            filters.push(filter)
        }
    } else {
        if (alreadyExists >= 0) {
            filters.splice(alreadyExists, 1)
        }
    }

    return filters
}

const initialParams: Params = {
    page: 1,
    limit: 5
}

let  store: StateCreator<LabsStore, [], [], LabsStore> | StoreApi<LabsStore> = (set: SetState<LabsStore>) => ({
    data: null,
    setdata: (x: any) => {
        set(state => ({ data : cloneDeep(x) }))
    },
    noData: true,
    setnoData: (noData: boolean) => {
        set(state => ({ noData }))
    },
    count: 13,
    setcount: (count: number) => {
        set(state => ({ count }))
    },
    dataCardId: undefined,
    setdataCardId: (dataCardId: number) => {
        set(state => ({ dataCardId }))
    },
    fetchRedValues: false,
    setfetchRedValues: (fetchRedValues: boolean) => {
        set(state => (
            {
                fetchRedValues, 
                params: {
                    ...state.params,
                    page: 1
                }
            }
        ))
    },
    params: clone(initialParams),
    setPage: (page: Params['page']) => {
        set(state => {
            let params = cloneDeep(state.params)
            params.page = page

            return { params }
        })
    },
    setLimit: (limit: Params['limit']) => {
        set(state => {
            let params = cloneDeep(state.params)
            params.limit = limit
            params.page = 1

            return { params }
        })
    },
    setSorting: (sortBy: Params['sortBy'], sortType: Params['sortType']) => {
        set(state => {
            let params = cloneDeep(state.params)
            params.sortBy = sortBy
            params.sortType = sortType

            return { params }
        })
    },
    setParams: (params: Params) => {
        set(state => {
            return { params }
        })
    },
    resetParams: () => {
        set(state => {
            let params = clone(initialParams)

            return { params }
        })
    },
    filters: [],
    setFilter: (columnName: Filter['columnName'], searchText: Filter['searchText']) => {
        set(state => {
            const filters = applySearchFilter(state.filters, columnName, searchText)
            return {
                params: {
                    ...state.params,
                    page: 1
                },
                filters
            }
        })
    },
    clearFilter: (columnName: Filter['columnName']) => {
        set(state => {
            return {
                params: {
                    ...state.params,
                    page: 1
                },
                filters: applySearchFilter(state.filters, columnName)
            }
        })
    },
    resetFilter: () => {
        set(state => ({ filters: [] }))
    },
    resetAll: () => {
        return {
            fetchRedValues: false,
            params: clone(initialParams),
            filters: []
        }
    },
    clearStore: () => {
        set(() => ({data:  null, dataCardId: undefined}));
    },
    patientId: undefined,
    setPatientId: (patientId) => {
        set(state => ({ patientId }))
    },
})


export const useLabsStore  = create(store)
